const a = {
  purple: {
    50: {
      hex: "#f8f2ff",
      cssVariable: "--cr-color-purple-50"
    },
    100: {
      hex: "#eedeff",
      cssVariable: "--cr-color-purple-100"
    },
    200: {
      hex: "#dcbbff",
      cssVariable: "--cr-color-purple-200"
    },
    300: {
      hex: "#ad5dfc",
      cssVariable: "--cr-color-purple-300"
    },
    400: {
      hex: "#8840d7",
      cssVariable: "--cr-color-purple-400"
    },
    500: {
      hex: "#6222b2",
      cssVariable: "--cr-color-purple-500"
    },
    600: {
      hex: "#561a9f",
      cssVariable: "--cr-color-purple-600"
    },
    700: {
      hex: "#4b118c",
      cssVariable: "--cr-color-purple-700"
    },
    800: {
      hex: "#3f0979",
      cssVariable: "--cr-color-purple-800"
    },
    900: {
      hex: "#330066",
      cssVariable: "--cr-color-purple-900"
    }
  },
  white: {
    hex: "#ffffff",
    cssVariable: "--cr-color-white"
  },
  neutral: {
    50: {
      hex: "#f7f7f7",
      cssVariable: "--cr-color-neutral-50"
    },
    100: {
      hex: "#eeeeee",
      cssVariable: "--cr-color-neutral-100"
    },
    200: {
      hex: "#bdbdbd",
      cssVariable: "--cr-color-neutral-200"
    },
    300: {
      hex: "#868686",
      cssVariable: "--cr-color-neutral-300"
    },
    400: {
      hex: "#5b5b5b",
      cssVariable: "--cr-color-neutral-400"
    },
    500: {
      hex: "#282828",
      cssVariable: "--cr-color-neutral-500"
    },
    600: {
      hex: "#1b1b1b",
      cssVariable: "--cr-color-neutral-600"
    },
    700: {
      hex: "#141414",
      cssVariable: "--cr-color-neutral-700"
    },
    800: {
      hex: "#0d0d0d",
      cssVariable: "--cr-color-neutral-800"
    },
    900: {
      hex: "#000000",
      cssVariable: "--cr-color-neutral-900"
    }
  },
  blueGrey: {
    50: {
      hex: "#f5fafa",
      cssVariable: "--cr-color-blueGrey-50"
    },
    100: {
      hex: "#edf2f2",
      cssVariable: "--cr-color-blueGrey-100"
    },
    200: {
      hex: "#e3e8e8",
      cssVariable: "--cr-color-blueGrey-200"
    },
    300: {
      hex: "#dce0e0",
      cssVariable: "--cr-color-blueGrey-300"
    },
    400: {
      hex: "#d4d9d9",
      cssVariable: "--cr-color-blueGrey-400"
    },
    500: {
      hex: "#c8cccc",
      cssVariable: "--cr-color-blueGrey-500"
    },
    600: {
      hex: "#afb2b2",
      cssVariable: "--cr-color-blueGrey-600"
    },
    700: {
      hex: "#969999",
      cssVariable: "--cr-color-blueGrey-700"
    },
    800: {
      hex: "#7d8080",
      cssVariable: "--cr-color-blueGrey-800"
    }
  },
  lime: {
    100: {
      hex: "#f8ffe6",
      cssVariable: "--cr-color-lime-100"
    },
    200: {
      hex: "#ebffb8",
      cssVariable: "--cr-color-lime-200"
    },
    300: {
      hex: "#deff8b",
      cssVariable: "--cr-color-lime-300"
    },
    400: {
      hex: "#d1ff5d",
      cssVariable: "--cr-color-lime-400"
    },
    500: {
      hex: "#c4ff2f",
      cssVariable: "--cr-color-lime-500"
    },
    600: {
      hex: "#79ea00",
      cssVariable: "--cr-color-lime-600"
    },
    700: {
      hex: "#6dd400",
      cssVariable: "--cr-color-lime-700"
    },
    800: {
      hex: "#56a700",
      cssVariable: "--cr-color-lime-800"
    },
    900: {
      hex: "#3f7a00",
      cssVariable: "--cr-color-lime-900"
    }
  },
  flamingo: {
    100: {
      hex: "#ffe6ee",
      cssVariable: "--cr-color-flamingo-100"
    },
    200: {
      hex: "#ffbbd1",
      cssVariable: "--cr-color-flamingo-200"
    },
    300: {
      hex: "#ff91b4",
      cssVariable: "--cr-color-flamingo-300"
    },
    400: {
      hex: "#ff6697",
      cssVariable: "--cr-color-flamingo-400"
    },
    500: {
      hex: "#ff3b7a",
      cssVariable: "--cr-color-flamingo-500"
    },
    600: {
      hex: "#d93268",
      cssVariable: "--cr-color-flamingo-600"
    },
    700: {
      hex: "#a6264f",
      cssVariable: "--cr-color-flamingo-700"
    },
    800: {
      hex: "#912145",
      cssVariable: "--cr-color-flamingo-800"
    },
    900: {
      hex: "#731b37",
      cssVariable: "--cr-color-flamingo-900"
    }
  },
  sky: {
    100: {
      hex: "#e6ffff",
      cssVariable: "--cr-color-sky-100"
    },
    200: {
      hex: "#cafdfc",
      cssVariable: "--cr-color-sky-200"
    },
    300: {
      hex: "#abfbfa",
      cssVariable: "--cr-color-sky-300"
    },
    400: {
      hex: "#88f7f5",
      cssVariable: "--cr-color-sky-400"
    },
    500: {
      hex: "#58f6f4",
      cssVariable: "--cr-color-sky-500"
    },
    600: {
      hex: "#00dcd4",
      cssVariable: "--cr-color-sky-600"
    },
    700: {
      hex: "#00b8b5",
      cssVariable: "--cr-color-sky-700"
    },
    800: {
      hex: "#009593",
      cssVariable: "--cr-color-sky-800"
    },
    900: {
      hex: "#004d4c",
      cssVariable: "--cr-color-sky-900"
    }
  },
  system: {
    error: {
      100: {
        hex: "#fde8ed",
        cssVariable: "--color-error-100"
      },
      500: {
        hex: "#e52e5c",
        cssVariable: "--color-error-500"
      },
      600: {
        hex: "#a62142",
        cssVariable: "--color-error-600"
      }
    },
    alert: {
      100: {
        hex: "#fdefc4",
        cssVariable: "--color-alert-100"
      },
      500: {
        hex: "#fac832",
        cssVariable: "--color-alert-500"
      },
      600: {
        hex: "#664f0a",
        cssVariable: "--color-alert-600"
      }
    },
    warning: {
      100: {
        hex: "#fdefc4",
        cssVariable: "--color-alert-100"
      },
      500: {
        hex: "#fac832",
        cssVariable: "--color-alert-500"
      },
      600: {
        hex: "#664f0a",
        cssVariable: "--color-alert-600"
      }
    },
    info: {
      100: {
        hex: "#dce2fa",
        cssVariable: "--color-info-100"
      },
      500: {
        hex: "#5975ff",
        cssVariable: "--color-info-500"
      },
      600: {
        hex: "#3e52b2",
        cssVariable: "--color-info-600"
      }
    },
    success: {
      100: {
        hex: "#cff6e3",
        cssVariable: "--color-success-100"
      },
      500: {
        hex: "#14cc70",
        cssVariable: "--color-success-500"
      },
      600: {
        hex: "#1b8751",
        cssVariable: "--color-success-600"
      }
    }
  },
  transparent: {
    dark: {
      30: {
        hex: "#0000004d",
        cssVariable: "--cr-color-transparent-dark-30"
      },
      50: {
        hex: "#00000080",
        cssVariable: "--cr-color-transparent-dark-50"
      },
      80: {
        hex: "#000000cc",
        cssVariable: "--cr-color-transparent-dark-50"
      }
    },
    light: {
      30: {
        hex: "#ffffff4d",
        cssVariable: "--cr-color-transparent-light-30"
      },
      50: {
        hex: "#ffffff80",
        cssVariable: "--cr-color-transparent-light-50"
      }
    }
  }
}, c = {
  none: { rem: 0, cssVariable: "--cr-space-none" },
  half: { rem: 0.125, cssVariable: "--cr-space-half" },
  1: { rem: 0.25, cssVariable: "--cr-space-1" },
  2: { rem: 0.5, cssVariable: "--cr-space-2" },
  3: { rem: 0.75, cssVariable: "--cr-space-3" },
  4: { rem: 1, cssVariable: "--cr-space-4" },
  5: { rem: 1.25, cssVariable: "--cr-space-5" },
  6: { rem: 1.5, cssVariable: "--cr-space-6" },
  7: { rem: 1.75, cssVariable: "--cr-space-7" },
  8: { rem: 2, cssVariable: "--cr-space-8" },
  9: { rem: 2.25, cssVariable: "--cr-space-9" },
  10: { rem: 2.5, cssVariable: "--cr-space-10" },
  11: { rem: 2.75, cssVariable: "--cr-space-11" },
  12: { rem: 3, cssVariable: "--cr-space-12" },
  13: { rem: 3.25, cssVariable: "--cr-space-13" },
  14: { rem: 3.5, cssVariable: "--cr-space-14" },
  15: { rem: 3.75, cssVariable: "--cr-space-15" },
  16: { rem: 4, cssVariable: "--cr-space-16" }
}, l = {
  sizeNone: { rem: 0, cssVariable: "--spacing-none" },
  size2: { rem: 0.125, cssVariable: "--spacing-size-2" },
  size4: { rem: 0.25, cssVariable: "--spacing-size-4" },
  size8: { rem: 0.5, cssVariable: "--spacing-size-8" },
  size12: { rem: 0.75, cssVariable: "--spacing-size-12" },
  size16: { rem: 1, cssVariable: "--spacing-size-16" },
  size20: { rem: 1.25, cssVariable: "--spacing-size-20" },
  size24: { rem: 1.5, cssVariable: "--spacing-size-24" },
  size28: { rem: 1.75, cssVariable: "--spacing-size-28" },
  size32: { rem: 2, cssVariable: "--spacing-size-32" },
  size36: { rem: 2.25, cssVariable: "--spacing-size-36" },
  size40: { rem: 2.5, cssVariable: "--spacing-size-40" },
  size44: { rem: 2.75, cssVariable: "--spacing-size-44" },
  size48: { rem: 3, cssVariable: "--spacing-size-48" },
  size52: { rem: 3.25, cssVariable: "--spacing-size-52" },
  size56: { rem: 3.5, cssVariable: "--spacing-size-56" },
  size60: { rem: 3.75, cssVariable: "--spacing-size-60" },
  size64: { rem: 4, cssVariable: "--spacing-size-64" },
  size80: { rem: 5, cssVariable: "--spacing-size-80" },
  size96: { rem: 6, cssVariable: "--spacing-size-96" },
  size112: { rem: 7, cssVariable: "--spacing-size-112" },
  size120: { rem: 7.5, cssVariable: "--spacing-size-120" },
  size128: { rem: 8, cssVariable: "--spacing-size-128" }
}, i = {
  ...c,
  ...l
}, o = {
  font: {
    primary: {
      value: "Coco Sharp",
      cssVariable: "--text-display-font-family"
    },
    secondary: {
      value: "Nunito Sans",
      cssVariable: "--text-body-font-family"
    }
  },
  fontWeight: {
    400: {
      value: "400",
      cssVariable: "--cr-font-weight-400"
    },
    700: {
      value: "700",
      cssVariable: "--cr-font-weight-700"
    },
    800: {
      value: "800",
      cssVariable: "--cr-font-weight-800"
    }
  },
  fontSize: {
    10: {
      rem: 0.625,
      cssVariable: "--cr-font-size-10"
    },
    12: {
      rem: 0.75,
      cssVariable: "--cr-font-size-12"
    },
    14: {
      rem: 0.875,
      cssVariable: "--cr-font-size-14"
    },
    16: {
      rem: 1,
      cssVariable: "--cr-font-size-16"
    },
    18: {
      rem: 1.125,
      cssVariable: "--cr-font-size-18"
    },
    20: {
      rem: 1.25,
      cssVariable: "--cr-font-size-20"
    },
    24: {
      rem: 1.5,
      cssVariable: "--cr-font-size-24"
    },
    28: {
      rem: 1.75,
      cssVariable: "--cr-font-size-28"
    },
    32: {
      rem: 2,
      cssVariable: "--cr-font-size-32"
    },
    36: {
      rem: 2.25,
      cssVariable: "--cr-font-size-36"
    },
    40: {
      rem: 2.5,
      cssVariable: "--cr-font-size-40"
    },
    48: {
      rem: 3,
      cssVariable: "--cr-font-size-48"
    },
    52: {
      rem: 3.25,
      cssVariable: "--cr-font-size-52"
    },
    56: {
      rem: 3.5,
      cssVariable: "--cr-font-size-56"
    },
    60: {
      rem: 3.75,
      cssVariable: "--cr-font-size-60"
    },
    64: {
      rem: 4,
      cssVariable: "--cr-font-size-64"
    },
    72: {
      rem: 4.5,
      cssVariable: "--cr-font-size-72"
    },
    80: {
      rem: 5,
      cssVariable: "--cr-font-size-80"
    }
  },
  lineHeight: {
    12: {
      rem: 0.75,
      cssVariable: "--cr-font-line-height-12"
    },
    16: {
      rem: 1,
      cssVariable: "--cr-font-line-height-16"
    },
    20: {
      rem: 1.25,
      cssVariable: "--cr-font-line-height-20"
    },
    24: {
      rem: 1.5,
      cssVariable: "--cr-font-line-height-24"
    },
    28: {
      rem: 1.75,
      cssVariable: "--cr-font-line-height-28"
    },
    32: {
      rem: 2,
      cssVariable: "--cr-font-line-height-32"
    },
    36: {
      rem: 2.25,
      cssVariable: "--cr-font-line-height-36"
    },
    40: {
      rem: 2.5,
      cssVariable: "--cr-font-line-height-40"
    },
    48: {
      rem: 3,
      cssVariable: "--cr-font-line-height-48"
    },
    52: {
      rem: 3.25,
      cssVariable: "--cr-font-line-height-52"
    },
    60: {
      rem: 3.75,
      cssVariable: "--cr-font-line-height-60"
    },
    72: {
      rem: 4.5,
      cssVariable: "--cr-font-line-height-72"
    },
    80: {
      rem: 5,
      px: 80,
      cssVariable: "--cr-font-line-height-80"
    }
  },
  spacing: {
    4: {
      rem: 0.025,
      cssVariable: "--cr-font-spacing-04"
    }
  },
  paragraph: {
    8: {
      rem: 1,
      cssVariable: "--cr-font-paragraph-8"
    }
  }
}, b = {
  xs: {
    value: "0px 1px 4px 0px rgba(0, 0, 0, 0.24)",
    cssVariable: "--cr-shadow-xs"
  },
  sm: {
    value: "0px 4px 10px 0px rgba(0, 0, 0, 0.2)",
    cssVariable: "--cr-shadow-sm"
  },
  md: {
    value: "0px 10px 20px 0px rgba(0, 0, 0, 0.16)",
    cssVariable: "--cr-shadow-md"
  }
}, V = {
  radius: {
    none: {
      rem: 0,
      cssVariable: "--border-radius-none"
    },
    xs: {
      rem: 0.5,
      cssVariable: "--border-radius-xs"
    },
    "2xs": {
      rem: 0.25,
      cssVariable: "--border-radius-2xs"
    },
    sm: {
      rem: 0.75,
      cssVariable: "--border-radius-sm"
    },
    md: {
      rem: 1,
      cssVariable: "--border-radius-md"
    },
    lg: {
      rem: 1.5,
      cssVariable: "--border-radius-lg"
    },
    xl: {
      rem: 2,
      cssVariable: "--border-radius-xl"
    },
    "2xl": {
      rem: 3,
      cssVariable: "--border-radius-2xl"
    },
    full: {
      px: 1e4,
      cssVariable: "--border-radius-full"
    },
    buttonRadius: {
      rem: 0.5,
      cssVariable: "--button-radius"
    }
  },
  1: {
    rem: 1,
    cssVariable: "--cr-border-1"
  },
  2: {
    rem: 0.125,
    cssVariable: "--cr-border-2"
  },
  crRadius: {
    none: {
      rem: 0,
      cssVariable: "--cr-border-radius-none"
    },
    xs: {
      rem: 0.125,
      cssVariable: "--cr-border-radius-xs"
    },
    "2xs": {
      rem: 0.125,
      cssVariable: "--border-radius-2xs"
    },
    sm: {
      rem: 0.25,
      cssVariable: "--cr-border-radius-sm"
    },
    md: {
      rem: 0.5,
      cssVariable: "--cr-border-radius-md"
    },
    lg: {
      rem: 1,
      cssVariable: "--cr-border-radius-lg"
    },
    xl: {
      rem: 2,
      cssVariable: "--cr-border-radius-xl"
    },
    "2xl": {
      rem: 2,
      cssVariable: "--border-radius-2xl"
    },
    full: {
      percent: 50,
      cssVariable: "--cr-border-radius-full"
    },
    buttonRadius: {
      rem: 0.5,
      cssVariable: "--button-radius"
    }
  }
}, f = (r, e = 16) => r * e, n = (r) => {
  if (r.value)
    return r.value;
  if (r.hex)
    return r.hex;
  if (r.percent)
    return `${r.percent}%`;
  if (r.rem)
    return `${r.rem}rem`;
  if (r.px)
    return `${r.px}px`;
}, t = (r) => `var(${r.cssVariable}, ${n(r)})`, m = (r) => `rgb(var(${r.cssVariable}) / <alpha-value>)`, h = (r, e = "web") => {
  switch (e) {
    case "mobile":
      if (r.value)
        return r.value;
      if (r.hex)
        return r.hex;
      if (r.percent)
        return `${r.percent}%`;
      if (r.rem)
        return `${f(r.rem)}px`;
      break;
    default:
      if (r.value)
        return r.value;
      if (r.hex)
        return r.hex;
      if (r.percent)
        return `${r.percent}%`;
      if (r.rem)
        return `${r.rem}rem`;
      break;
  }
};
function x(r) {
  const e = {};
  return [0, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900].forEach((s) => {
    e[s] = m({ cssVariable: `--color-${r}-${s}` });
  }), e;
}
const p = {
  colors: a,
  space: i,
  typography: o,
  border: V,
  shadow: b
};
export {
  x as getColorPalete,
  t as token,
  m as tokenRgb,
  h as tokenValue,
  p as tokens
};
